import { cn } from '~/lib/utils';

function Stack({
  children,
  col,
  gap,
  className,
}: {
  children: React.ReactNode;
  col?: boolean;
  gap?: number;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col gap-y-2 gap-x-4',
        col ? 'flex-col' : 'flex-row',
        gap && `gap-${gap}`,
        className,
      )}
    >
      {children}
    </div>
  );
}

export default Stack;
